<div class="flex items-center" mat-dialog-title>
  <h2 class="headline m-0 flex-auto">{{ editing ? "Modifier l'équipe" : 'Créer une équipe' }}</h2>
  <button mat-icon-button type="button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-divider class="-mx-6"></mat-divider>

<mat-dialog-content class="pt-4 flex flex-col">
  <div class="flex flex-col sm:flex-row sm:gap-3">
    <mat-form-field appearance="outline" class="flex-auto">
      <mat-label>Nom</mat-label>
      <input matInput required [(ngModel)]="name" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="flex-auto">
      <mat-label>Adresse commune</mat-label>
      <input matInput required type="email" placeholder="equipe@exemple.fr" [(ngModel)]="email" />
      <mat-hint>Les mails de l'équipe y sont envoyés</mat-hint>
    </mat-form-field>
  </div>

  <div class="flex flex-col sm:flex-row sm:gap-3 mt-2">
    <mat-form-field appearance="outline" class="flex-auto">
      <mat-label>Rôle</mat-label>
      <mat-select required [(ngModel)]="role" (selectionChange)="refresh()">
        <mat-option *ngFor="let item of roles" [value]="item">{{ item }}</mat-option>
      </mat-select>
      <mat-hint>Un seul rôle par équipe</mat-hint>
    </mat-form-field>
    <mat-form-field appearance="outline" class="flex-auto">
      <mat-label>Établissement support</mat-label>
      <mat-select required [(ngModel)]="support" [disabled]="supportLocked" (selectionChange)="refresh()">
        <mat-option *ngFor="let item of supports" [value]="item">{{ item.name }}</mat-option>
      </mat-select>
      <mat-hint *ngIf="supportLocked">Celui de la fiche ouverte</mat-hint>
    </mat-form-field>
  </div>

  <!-- PÉRIMÈTRE DÉDUIT -->
  <div class="rounded bg-gray-light px-3 py-2 mt-2 mb-4 flex items-start gap-3">
    <mat-icon class="text-secondary flex-none">apartment</mat-icon>
    <div>
      <p class="m-0 body-2">Périmètre</p>
      <p class="m-0 caption text-secondary">
        {{
          support ? perimeter : "Choisissez l'établissement support : ses établissements clients forment le périmètre"
        }}
      </p>
    </div>
  </div>

  <!-- MEMBRES -->
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Membres</mat-label>
    <mat-select multiple [(ngModel)]="memberIds" [disabled]="!rules" (selectionChange)="refresh()">
      <mat-select-trigger>{{ selectedNames }}</mat-select-trigger>
      <mat-option *ngFor="let candidate of candidates" [value]="candidate.person.id" [disabled]="isLocked(candidate)">
        {{ candidate.person.fullName }}
        <span class="caption" [ngClass]="candidate.issue ? 'text-warn' : 'text-secondary'">
          · {{ candidate.issue ?? candidate.establishments }}
        </span>
      </mat-option>
    </mat-select>
    <mat-hint>
      {{
        rules
          ? 'Avoir le rôle et au moins une affectation dans le périmètre'
          : "Choisissez d'abord le rôle et l'établissement support"
      }}
    </mat-hint>
  </mat-form-field>

  <!-- CONSÉQUENCES D'UNE MODIFICATION -->
  <div *ngIf="warnings.length" class="rounded border border-orange px-3 py-2 mt-6 flex flex-col gap-2">
    <p *ngFor="let warning of warnings" class="m-0 body-1 flex items-start gap-2">
      <mat-icon class="text-orange flex-none">error</mat-icon>
      {{ warning }}
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">ANNULER</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!valid" (click)="save()">
    {{ editing ? 'ENREGISTRER' : 'CRÉER' }}
  </button>
</mat-dialog-actions>
